import StoreContainer from "./StoreContainer";

export default class LanguageStore {
  setDisplayName(languageDisplayName: string) {
    StoreContainer.LocalStorageStore.set(
      "languageDisplayName",
      languageDisplayName
    );
  }

  getDisplayName() {
    return StoreContainer.LocalStorageStore.get("languageDisplayName");
  }
}
